import type { AllRouteEndpoints } from "../routeTypes";

export const appGroupIdOperatorMcpConnections = "/:app_group_id/operator_mcp_connections";

export const postAppGroupIdOperatorMcpConnectionsCacheKeys: AllRouteEndpoints[] = [
  "/:app_group_id/operator_mcp_connections",
  "/:app_group_id/operator_mcp_connections/tools",
];
